// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ne-0";